import { Column, LoadingSkeleton, StyledCellHeader, StyledTableCell } from '@components';
import { useMediaQuery, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import Highlighter from 'react-highlight-words';
import removeAccents from 'remove-accents';

export type TableCellProps = {
  fieldName?: string;
  fieldValue?: string | JSX.Element | null;
  searchWords: Array<string>;
  filteredColumns?: Array<Column>;
  visibleColumnNames?: Array<string>;
  isWorking?: boolean;
  component?: ReactNode;
  isBold?: boolean;
};

export const TableCell = ({
  fieldName = '',
  fieldValue = '',
  isWorking,
  visibleColumnNames,
  filteredColumns,
  searchWords,
  component,
  isBold,
}: TableCellProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const headerName = filteredColumns?.find((x) => x.key === fieldName)?.name;
  const isColumnEnabled = visibleColumnNames?.includes(fieldName.toLowerCase());
  const isCellEmpty = !fieldValue && !component;
  const showCell = isColumnEnabled && !(isSmallScreen && isCellEmpty);

  return showCell ? (
    <StyledTableCell isbold={isBold?.toString()}>
      <StyledCellHeader component='span'>{headerName}:</StyledCellHeader>
      {fieldValue &&
        !isWorking &&
        (typeof fieldValue === 'string' ? (
          // @ts-ignore
          <Highlighter
            highlightClassName='highlighted'
            searchWords={searchWords}
            autoEscape={true}
            sanitize={(text) => removeAccents(text)}
            textToHighlight={fieldValue?.toString() || ''}
          />
        ) : (
          fieldValue
        ))}
      {!isWorking && component}
      {isWorking && <LoadingSkeleton />}
    </StyledTableCell>
  ) : null;
};
